<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>ترکیب</th>
                    <th>سطح کاربر برای دریاقت</th>
                    <th>وضعیت</th>
                    <th>دیفالت</th>
                    <th>جایزه آموزش</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="formation in formations" :key="formation._id">
                    <td>{{ formation.formationName }}</td>
                    <td>{{ formation.minLevel }}</td>
                    <td>{{ formation.isAvailable ? 'فعال' : 'غیر فعال' }}</td>
                    <td>{{ formation.isDefault ? 'اصلی' : 'فرعی' }}</td>
                    <td>{{ formation.isReward ? 'بله' : 'خیر' }}</td>
                    <td>
                      <router-link :to="{ path: '/dashboard/formation', query: { id: formation._id } }"
                        >مشاهده</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formationService from '../../../../services/formation';
export default {
  name: 'formations',
  data() {
    return {
      formations: [],
    };
  },
  created() {
    this.getFormations();
  },
  methods: {
    async getFormations() {
      try {
        const condition = {};
        const resData = await formationService.getAllFormations(condition);
        console.log(resData);
        this.formations = resData;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
